import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Buffer } from 'buffer';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import jwtDecode from 'jwt-decode';

function SignOutPage() {
  const navigate = useNavigate();

  const getBody = () => {
    const formData = new FormData();
    formData.append("refreshToken", localStorage.getItem('refresh_token'));
    formData.append('token', localStorage.getItem('token'));
    formData.append("access_token", localStorage.getItem('access_token'));
    return formData
  }

  useEffect(() => {
    //document.cookie = "JSESSIONID=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    logoutSession();
  }, []);

  const revokeToken = async () => {

    const url = process.env.REACT_APP_API_KEY_URL + 'oauth2/revoke';
    try {
      await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': 'Basic ' + Buffer.from(process.env.REACT_APP_OAUTH_CLIENT_NAME + ':' + process.env.REACT_APP_OAUTH_CLIENT_SECRET).toString('base64')
        },
        mode: 'cors',
        body: getBody()
      });
      await logoutSession();
    } catch (error) {
      console.log('Error: ', error);
    }
  }

  const getRefreshBody = () => {
    const formData = new FormData();

    formData.append(
      oAuthServiceConfig.grantType,
      process.env.REACT_APP_OAUTH_REFRESH_GRANT_TYPE
    );
    formData.append(
      oAuthServiceConfig.refreshToken,
      localStorage.getItem("refresh_token")
    );
    return formData;
  };


  const logoutSession = async () => {
    try {
      const decodedJwt = jwtDecode(localStorage.getItem("token"));

      if (decodedJwt.exp * 1000 < Date.now()) {
        const response = await fetch(
          `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.token}`,
          {
            method: "POST",
            headers: {
              Authorization:
                "Basic " +
                Buffer.from(
                  process.env.REACT_APP_OAUTH_CLIENT_NAME +
                  ":" +
                  process.env.REACT_APP_OAUTH_CLIENT_SECRET
                ).toString("base64"),
            },
            mode: "cors",
            body: getRefreshBody(),
          }
        );
        const token = await response.json();
        if (token.id_token) {
          const url =
            process.env.REACT_APP_API_KEY_URL + "connect/logout";
          const savedTheme =
            localStorage.getItem("fuseSelectedTheme");
          localStorage.clear();
          if (savedTheme) {
            localStorage.setItem(
              "fuseSelectedTheme",
              savedTheme
            );
          }

          window.location =
            url +
            "?id_token_hint=" +
            token.id_token +
            "&post_logout_redirect_uri=" +
            window.location.origin +
            "/redirect";
        }
      } else {
        const url =
          process.env.REACT_APP_API_KEY_URL + "connect/logout";
        const savedTheme =
          localStorage.getItem("fuseSelectedTheme");
        const idToken =
          localStorage.getItem("token");
        localStorage.clear();
        if (savedTheme) {
          localStorage.setItem(
            "fuseSelectedTheme",
            savedTheme
          );
        }
        window.location =
          url +
          "?id_token_hint=" +
          idToken +
          "&post_logout_redirect_uri=" +
          window.location.origin +
          "/redirect";
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="flex flex-col flex-auto items-center sm:justify-center min-w-0">
      <Paper className="flex items-center w-full sm:w-auto min-h-full sm:min-h-auto rounded-0 py-32 px-16 sm:p-48 sm:rounded-2xl sm:shadow">
        <div className="w-full max-w-320 sm:w-320 mx-auto sm:mx-0">
          <img className="w-48 mx-auto" src="assets/images/logo/LOGO.png" alt="logo" />

          <Typography className="mt-32 text-4xl font-extrabold tracking-tight leading-tight text-center">
            You have signed out!
          </Typography>
        </div>
      </Paper>
    </div>
  );
}

export default SignOutPage;
